<template>
  <div
    class="min-h-screen bg-gray-50 px-4 py-6 pb-24 categories-page"
    dir="rtl"
    :class="{ 'categories-skeleton-group': pageLoading }"
  >
    <div class="mx-auto max-w-lg md:max-w-none">

      <!-- Skeleton -->
      <div v-if="pageLoading" class="picker-list" aria-hidden="true">
        <div
          v-for="n in skeletonCardCount"
          :key="'cat-sk-' + n"
          class="picker-card picker-card--skeleton"
        >
          <div class="picker-card__inner">
            <div class="picker-card__main">
              <div class="skeleton-block picker-skeleton-icon"></div>
              <div class="skeleton-block picker-skeleton-title"></div>
            </div>
            <div class="skeleton-block picker-skeleton-chevron"></div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-else-if="items.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">هنوز دسته‌بندی‌ای اضافه نشده است</p>
      </div>

      <!-- Categories List -->
      <div v-else class="picker-list">
        <button
          v-for="item in items"
          :key="item.Id"
          type="button"
          class="picker-card"
          @click="goToDetail(item.Id)"
        >
          <div class="picker-card__inner">
            <div class="picker-card__main">
              <div class="picker-card__icon">
                <img
                  :src="item.ImageUrl"
                  :alt="item.ProductTypeTitle"
                  class="picker-card__icon-img"
                />
              </div>
              <h3 class="picker-card__title">{{ item.ProductTypeTitle }}</h3>
            </div>
            <svg class="picker-card__chevron" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </div>
        </button>
      </div>

    </div>
  </div>
</template>
<script>
  import { skeletonSilentRequest } from '../../utils/skeletonPages'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        items: [],
        pageLoading: true,
        skeletonCardCount: 11,
      }
    },
    async mounted () {
      const passing_data = JSON.parse(localStorage.getItem('request_data'))
      console.log('response', passing_data.ServiceOutBranchOnFinalize)

      try {
        await this.get_categories()
      } finally {
        this.pageLoading = false
      }
    },
    methods: {
      goToDetail (item_id) {
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        passing_data.cat_id = item_id
        passing_data.request_name = this.$t('repair')
        localStorage.setItem('request_data', JSON.stringify(passing_data))

        this.$router.push({ name: 'groups', params: {} })
      },
      async get_categories () {
        const send_data = {
          Phone: this.mobile,
        }

        try {
          const response = await this.axios.post('/GetRequestTypeList', send_data, skeletonSilentRequest)
          if (response.data.error == 0) {
            console.log('response', response)
            this.items = response.data.Types || []
          }
        } catch (e) {
          this.errors.push(e)
        }
      }
    }
  }
</script>
<style scoped>
  .picker-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .picker-card {
    display: block;
    width: 100%;
    text-align: right;
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 0.75rem;
    padding: 0.75rem 1rem;
    cursor: pointer;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .picker-card:hover {
    border-color: #bfdbfe;
    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
  }

  .picker-card:active {
    transform: scale(0.995);
  }

  .picker-card--selected {
    background: #eff6ff;
    border-color: #93c5fd;
  }

  .picker-card__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    width: 100%;
  }

  .picker-card__main {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1;
    min-width: 0;
  }

  .picker-card__icon {
    flex-shrink: 0;
    width: 2.75rem;
    height: 2.75rem;
    padding: 0.5rem;
    border-radius: 0.625rem;
    background: #eef4ff;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .picker-card__icon-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .picker-card__title {
    flex: 1;
    min-width: 0;
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 700;
    line-height: 1.4;
    color: #1e3a5f;
  }

  .picker-card__chevron {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    color: #9ca3af;
  }

  .categories-skeleton-group {
    position: relative;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
  }

  .categories-skeleton-group::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.55) 45%,
      rgba(255, 255, 255, 0.65) 55%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: categories-skeleton-shimmer 1.4s ease-in-out infinite;
  }

  .skeleton-block {
    background-color: #e5e7eb;
  }

  .picker-skeleton-icon {
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 0.625rem;
    flex-shrink: 0;
  }

  .picker-skeleton-title {
    flex: 1;
    height: 0.9375rem;
    max-width: 10rem;
    border-radius: 6px;
  }

  .picker-skeleton-chevron {
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 4px;
    flex-shrink: 0;
  }

  @keyframes categories-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }
</style>
